require('prismic.io')
const getRespImgSrc = function (prismicObj, fieldName = 'image', profile = 'collection-portrait') {
  const w = window.innerWidth
  switch (profile) {
    case 'collection-portrait':
      let size = w > 600 ? 'tablet' : 'mobile'
      size = w > 1024 ? 'laptop' : size
      size = w > 1628 ? 'main' : size
      return prismicObj.getImageView(fieldName, size).url
    case 'imageset-mobile':
      size = w > 320 ? 'main' : 'narrow'
      return prismicObj.getImageView(fieldName, size).url
  }
  return null
}
module.exports = getRespImgSrc



// WEBPACK FOOTER //
// ./src/assets/js/getRespImgSrc.js